import { onlineManager } from '@tanstack/react-query';
import onlineClassificationTypesRepositoryOfflineAdapters from '../../../modules/offline/offlineRequestAdapters/onlineClassificationTypes.repository.offlineAdapters';
import onlineClassificationTypesRepository from './onlineClassificationTypes.repository';

const classificationTypesRepository = (isOfflineMode = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineClassificationTypesRepositoryOfflineAdapters()
    : onlineClassificationTypesRepository();

export default classificationTypesRepository;
